import { ResourceGroup } from "./ResourceGroup"
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react"
import { cn } from "../lib/utils"

export const CollapsibleResourceSection = ({ name, sections, defaultOpen, onOpenChange }) => {
  return (
    <Disclosure as="div" defaultOpen={defaultOpen}>
      {({ open }) => (
        <>
          <DisclosureButton
            className={cn(
              "group flex w-full items-center justify-between px-4 py-4 transition-all duration-500 transform bg-brandSecondary font-bold text-white hover:bg-brandSecondary/80"
            )}
            onClick={() => onOpenChange(name, !open)}
          >
            <span className="text-left text-lg">{name}</span>
            <i
              className={cn(
                "fa-solid fa-chevron-down text-lg transition-transform duration-400",
                open ? "rotate-180" : "",
              )}
            ></i>
          </DisclosureButton>

          <DisclosurePanel className="bg-transparent">
            <div className="mx-auto flex max-w-screen-lg flex-col gap-4 bg-transparent pt-8">
              {sections.map(section => (
                <ResourceGroup
                  key={section.name}
                  name={section.name}
                  resources={section.resources}
                />
              ))}
            </div>
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  )
}
